import tingle from "tingle.js";

import SmoothScroll from "./SmoothScroll";
import Navigation from "./Navigation";
import RecruitForm from "./RecruitForm";

(() => {
  const init = () => {
    Navigation();
    SmoothScroll(-48);
    RecruitForm();
    messageVideo();
  };

  window.addEventListener("DOMContentLoaded", () => {
    init();
  });

  document.addEventListener("touchstart", (event) => {}, { passive: true });
  document.addEventListener("wheel", (event) => {}, { passive: true });

  /**
   * メッセージのビデオ
   */
  const messageVideo = () => {
    const videoLinks = document.querySelectorAll(".js-messageVideo");
    if (!videoLinks) {
      return;
    }

    /**
     * modal 設定
     */
    const videoModals = [];
    const videoModalsHtml = [];
    videoLinks.forEach((videoLink, index) => {
      const href = videoLink.href;
      const videoName = JSON.parse(videoLink.dataset.videoname);

      /**
       * urlの分解
       */
      const matchedFileName =
        href.match(
          /^(?:[^:\/?#]+:)?(?:\/\/[^\/?#]*)?(?:([^?#]*\/)([^\/?#]*))?(\?[^#]*)?(?:#.*)?$/
        ) ?? [];
      const [, dir, fileName, query] = matchedFileName.map(
        (match) => match ?? ""
      );
      const matchedExt = fileName.match(/^(.+?)(\.[^.]+)?$/) ?? [];
      const [, name, ext] = matchedExt.map((match) => match ?? "");

      /**
       * modal 設定
       */
      videoModals[index] = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeLabel: "CLOSE",
        closeMethods: ["overlay", "button"],
        cssClass: ["video-modal"],
        onOpen: function () {
          // console.log("modal open");
        },
        onClose: function () {
          // console.log("modal closed");
        },
        beforeClose: function () {
          return true;
        },
      });

      let modalHtml = "";
      modalHtml += `<h3 class="video-modal__title"><span>${videoName.title}</span>${videoName.name}</h3>`;
      modalHtml += '<div class="video">';
      // modalHtml += `<video controls autoplay poster="${
      //   window.location.origin + dir + name
      // }.png" width="1024">`;
      modalHtml += `<video controls autoplay width="1024">`;
      modalHtml += `<source src="${
        window.location.origin + dir + name
      }.webm" type="video/webm">`;
      modalHtml += `<source src="${
        window.location.origin + dir + fileName
      }" type="video/mp4">`;
      modalHtml += "</video>";
      modalHtml += "</div>";
      videoModalsHtml[index] = modalHtml;

      /**
       * modal 開閉
       */
      videoLink.addEventListener("click", (event) => {
        event.preventDefault();
        videoModals[index].setContent(videoModalsHtml[index]);
        videoModals[index].open();
      });
    });
  };
})();
